import { render, staticRenderFns } from "./SocialAuthButtons.vue?vue&type=template&id=187aef87&scoped=true&"
import script from "./SocialAuthButtons.vue?vue&type=script&lang=js&"
export * from "./SocialAuthButtons.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthButtons.vue?vue&type=style&index=0&id=187aef87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187aef87",
  null
  
)

export default component.exports